import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { hideDialog, getDialogActionHandler } from "../../../redux/slices/alert/Alert.slice";
import { testIds } from "./GlobalDialog.testIds";

const GlobalDialog = () => {
  const dispatch = useDispatch();
  const dialog = useSelector((state: RootState) => state.alertReducer.dialog);
  const {
    isVisible: isDialogVisible,
    title,
    description,
    type: dialogType,
    actions,
  } = dialog;
  return (
    <Dialog
      open={!!isDialogVisible}
      onClose={
        actions?.length ? () => dispatch(hideDialog()) : undefined
      }
      disableEscapeKeyDown={!actions?.length}
      aria-labelledby="dialog-confirmation"
      aria-describedby="dialog-confirmation"
      sx={{
        zIndex: 9999,
      }}
    >
      <DialogTitle
        sx={{
          color:
            dialogType === "primary"
              ? "primary.main"
              : dialogType === "secondary"
              ? "secondary.main"
              : "error.main",
        }}
        id="dialog-confirmation"
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {(
          actions || [
            {
              title: "OK",
              type: dialogType,
            },
          ]
        ).map((action, index) => (
          <Button data-testid={`${testIds.globalDialogAction}-${action.title}`}
            color={action.type}
            onClick={() => {
              const handler = getDialogActionHandler(index);
              if (handler) {
                handler();
              } else {
                dispatch(hideDialog());
              }
            }}
            key={action.title}
            id={`dialog-action-${action.title}`}
          >
            {action.title}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default GlobalDialog;
